import React from "react";
import { MDCAnchorMenu, MDCMenu } from "../../jsx/components/mdc-components";
export class SearchFilter extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "heading-label search-dropdown"
    }, /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button with-heading light",
      "data-anchor": true
    }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons dark-color"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Source",
      "data-id": "Source"
    }, "Source"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Medium",
      "data-id": "Medium"
    }, "Medium"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Term",
      "data-id": "Term"
    }, "Term"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Content",
      "data-id": "Content"
    }, "Content"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Campaign",
      "data-id": "Campaign"
    }, "Campaign"))));
  }
}
class PagesFilter extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Url",
      "data-value": "url",
      "data-id": "url"
    }, "Url"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-default-selection": "url",
      "data-default-text": "Url",
      "data-text": "Pages Locations",
      "data-value": "pages_locations",
      "data-id": "search"
    }, "Search on Page Locations"));
  }
}
class PagesLocationsFilter extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Url",
      "data-value": "url",
      "data-id": "url"
    }, "Url"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Title",
      "data-value": "title",
      "data-id": "title"
    }, "Title"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "City",
      "data-value": "city",
      "data-id": "city"
    }, "City"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Postal Code",
      "data-value": "postal_code",
      "data-id": "postal_code"
    }, "Postal Code"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Region Code",
      "data-value": "region_code",
      "data-id": "region_code"
    }, "Region Code"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-default-selection": "url",
      "data-default-text": "Url",
      "data-text": "Pages",
      "data-value": "pages",
      "data-id": "search"
    }, "Search on Pages"));
  }
}
class LocationsFilter extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "City",
      "data-value": "city",
      "data-id": "city"
    }, "City"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Postal Code",
      "data-value": "postal_code",
      "data-id": "postal_code"
    }, "Postal Code"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Region Code",
      "data-value": "region_code",
      "data-id": "region_code"
    }, "Region Code"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-default-selection": "city",
      "data-default-text": "City",
      "data-text": "Places",
      "data-value": "places",
      "data-id": "search"
    }, "Search on Places"));
  }
}
class PlacesFilter extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "City",
      "data-value": "city",
      "data-id": "city"
    }, "City"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Postal Code",
      "data-value": "postal_code",
      "data-id": "postal_code"
    }, "Postal Code"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Region Code",
      "data-value": "region_code",
      "data-id": "region_code"
    }, "Region Code"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-default-selection": "city",
      "data-default-text": "City",
      "data-text": "Locations",
      "data-value": "locations",
      "data-id": "search"
    }, "Search on Locations"));
  }
}
class ProductFilter extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Title",
      "data-value": "title",
      "data-id": "title"
    }, "Title"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Sku",
      "data-value": "product_id",
      "data-id": "product_id"
    }, "Sku"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-default-selection": "city",
      "data-default-text": "City",
      "data-text": "Product Locations",
      "data-value": "product_locations",
      "data-id": "search"
    }, "Search on Product Locations"));
  }
}
class ProductLocationsFilter extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "City",
      "data-value": "city",
      "data-id": "city"
    }, "City"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Postal Code",
      "data-value": "postal_code",
      "data-id": "postal_code"
    }, "Postal Code"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-text": "Region Code",
      "data-value": "region_code",
      "data-id": "region_code"
    }, "Region Code"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-default-selection": "title",
      "data-default-text": "Title",
      "data-text": "Product",
      "data-value": "product",
      "data-id": "search"
    }, "Search on Product"));
  }
}
export class MultiSearchFilter extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    var type = this.props.type;
    type = type.toLowerCase();
    var id = this.props.id;
    if (type == 'product') {
      return /*#__PURE__*/React.createElement("div", {
        className: "heading-label search-dropdown"
      }, /*#__PURE__*/React.createElement(MDCAnchorMenu, {
        menuId: this.props.id,
        onMenuSelected: this.props.onSelected,
        cls: "small-list-item-size"
      }, /*#__PURE__*/React.createElement("button", {
        className: "anchor-menu-button with-heading light",
        "data-anchor": true
      }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
        className: "material-icons dark-color"
      }, "arrow_drop_down")), /*#__PURE__*/React.createElement(ProductFilter, {
        id: id
      })));
    } else if (type === 'product_locations') {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "heading-label search-dropdown"
      }, /*#__PURE__*/React.createElement(MDCAnchorMenu, {
        menuId: this.props.id,
        onMenuSelected: this.props.onSelected,
        cls: "small-list-item-size"
      }, /*#__PURE__*/React.createElement("button", {
        className: "anchor-menu-button with-heading light",
        "data-anchor": true
      }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
        className: "material-icons dark-color"
      }, "arrow_drop_down")), /*#__PURE__*/React.createElement(ProductLocationsFilter, {
        id: id
      }))));
    } else if (type === 'locations') {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "heading-label search-dropdown"
      }, /*#__PURE__*/React.createElement(MDCAnchorMenu, {
        menuId: this.props.id,
        onMenuSelected: this.props.onSelected,
        cls: "small-list-item-size"
      }, /*#__PURE__*/React.createElement("button", {
        className: "anchor-menu-button with-heading light",
        "data-anchor": true
      }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
        className: "material-icons dark-color"
      }, "arrow_drop_down")), /*#__PURE__*/React.createElement(LocationsFilter, {
        id: id
      }))));
    } else if (type === 'places') {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "heading-label search-dropdown"
      }, /*#__PURE__*/React.createElement(MDCAnchorMenu, {
        menuId: this.props.id,
        onMenuSelected: this.props.onSelected,
        cls: "small-list-item-size"
      }, /*#__PURE__*/React.createElement("button", {
        className: "anchor-menu-button with-heading light",
        "data-anchor": true
      }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
        className: "material-icons dark-color"
      }, "arrow_drop_down")), /*#__PURE__*/React.createElement(PlacesFilter, {
        id: id
      }))));
    } else if (type === 'pages') {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "heading-label search-dropdown"
      }, /*#__PURE__*/React.createElement(MDCAnchorMenu, {
        menuId: this.props.id,
        onMenuSelected: this.props.onSelected,
        cls: "small-list-item-size"
      }, /*#__PURE__*/React.createElement("button", {
        className: "anchor-menu-button with-heading light",
        "data-anchor": true
      }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
        className: "material-icons dark-color"
      }, "arrow_drop_down")), /*#__PURE__*/React.createElement(PagesFilter, {
        id: id
      }))));
    } else if (type === 'pages_locations') {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "hide"
      }), /*#__PURE__*/React.createElement("div", {
        className: "heading-label search-dropdown"
      }, /*#__PURE__*/React.createElement(MDCAnchorMenu, {
        menuId: this.props.id,
        onMenuSelected: this.props.onSelected,
        cls: "small-list-item-size"
      }, /*#__PURE__*/React.createElement("button", {
        className: "anchor-menu-button with-heading light",
        "data-anchor": true
      }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
        className: "material-icons dark-color"
      }, "arrow_drop_down")), /*#__PURE__*/React.createElement(PagesLocationsFilter, {
        id: id
      }))));
    }
  }
}
export default {
  SearchFilter,
  MultiSearchFilter
};